import React, { Component } from "react";
import { Field, Form, withFormik } from "formik";
import * as Yup from "yup";
import Aux from "../../../../../hoc/Auxilary";
import SelectionFields from "../../../../../hoc/UI/SelectionFields/SelectionFields";
import { Button } from "rsuite";

class ContractQualityAssuranceForm extends Component {
  render() {
    console.log("project id", this.props.projectID);
    const validAndHandle = (func, values) => {
      this.props.validateForm().then(errors => {
        if (Object.keys(errors).length !== 0) {
          this.props.setFieldTouched("proj_contract_id", true);
          this.props.setFieldTouched(
            "payments_withheld_due_to_non_conformance",
            true
          );
          console.log("cannot submit! Validation failed", errors);
        } else {
          values.project_id = this.props.projectID;
          func(values);
          this.props.resetForm();
          this.props.toggleSmallModalHandler();
        }
      });
    };

    return (
      <Form>
        {" "}
        <fieldset disabled={this.props.disabled}>
          {" "}
          <div
            onClick={this.props.toggleSmallModalHandler}
            style={{ color: "red", float: "right", cursor: "pointer" }}
          >
            x
          </div>
          <div>
            <small className={"d-block col-12"}>
              <span style={{ color: "red" }}>*</span> required
            </small>
            <SelectionFields
              showError={
                this.props.errors.proj_contract_id &&
                this.props.touched.proj_contract_id
              }
              size={"col-12"}
              id={"proj_contract_id"}
              url={`proj_contract/project_id/${this.props.projectID}`}
              showElem={"contract_name"}
              label={"Contract"}
              value={this.props.values["proj_contract_id"] || "default"}
              isRequired={true}
              errorMessage={
                this.props.errors.proj_contract_id &&
                this.props.touched.proj_contract_id && (
                  <small className={"text-danger"}>
                    {this.props.errors.proj_contract_id}
                  </small>
                )
              }
            />
          </div>
          <label
            className="col-12"
            style={
              this.props.errors.payments_withheld_due_to_non_conformance &&
              this.props.touched.payments_withheld_due_to_non_conformance && {
                color: "red"
              }
            }
          >
            Payments Withheld Due To Non Conformance
            <Field
              className="form-control-sm form-control"
              name={"payments_withheld_due_to_non_conformance"}
              value={
                this.props.values.payments_withheld_due_to_non_conformance ||
                null
              }
            />
            {this.props.errors.payments_withheld_due_to_non_conformance &&
              this.props.touched.payments_withheld_due_to_non_conformance && (
                <small className="text-danger">
                  {this.props.errors.payments_withheld_due_to_non_conformance}
                </small>
              )}
          </label>
          <label className="col-12">
            Non Conformance Work
            <Field
              component={"textarea"}
              className="form-control-sm form-control"
              name={"non_conformance_work"}
              value={this.props.values.non_conformance_work || ""}
            />
          </label>
          <label className="col-12">
            Non Conformance Work Correction
            <Field
              component={"textarea"}
              className="form-control-sm form-control"
              name={"non_conformance_work_correction"}
              value={this.props.values.non_conformance_work_correction || ""}
            />
          </label>
          <label className="col-12">
            Notes
            <Field
              component={"textarea"}
              className="form-control-sm form-control"
              name={"notes"}
              value={this.props.values.notes || ""}
            />
          </label>
        </fieldset>
        {this.props.disabled ? (
          <Button
            className={"ml-2"}
            type="button"
            onClick={this.props.toggleSmallModalHandler}
          >
            Cancel
          </Button>
        ) : (
          <div>
            {!this.props.currentContractQualityAssurance ? (
              <Aux>
                <Button
                  color={"blue"}
                  type="button"
                  onClick={() => {
                    validAndHandle(this.props.add, this.props.values);
                  }}
                >
                  Submit
                </Button>
                <Button
                  color="red"
                  className={"ml-2"}
                  type="button"
                  onClick={this.props.handleReset}
                >
                  Reset
                </Button>
              </Aux>
            ) : (
              <Aux>
                <Button
                  color={"blue"}
                  type="button"
                  onClick={() => {
                    validAndHandle(this.props.update, this.props.values);
                  }}
                >
                  Update
                </Button>
                <Button
                  color={"red"}
                  className={"ml-2"}
                  type="button"
                  onClick={this.props.handleReset}
                >
                  Reset
                </Button>
              </Aux>
            )}
            <Button
              className={"ml-2"}
              type="button"
              onClick={this.props.toggleSmallModalHandler}
            >
              Cancel
            </Button>
          </div>
        )}
      </Form>
    );
  }
}

var contractQualityAssuranceSchema = Yup.object().shape({
  proj_contract_id: Yup.string().required(),
  payments_withheld_due_to_non_conformance: Yup.number()
    .nullable()
    .typeError("Number required")
});

export default withFormik({
  validationSchema: contractQualityAssuranceSchema,
  enableReinitialize: true,

  mapPropsToValues({ currentContractQualityAssurance }) {
    return {
      ...currentContractQualityAssurance
    };
  }
})(ContractQualityAssuranceForm);
